export default "__VITE_ASSET__u0Am3V9q__"